module.exports = __webpack_public_path__ + "img/print_fingerprint.42d9daa.webp";